(function () {
  'use strict';

  const STORAGE_KEY = 'bitandbyte:favorites:v1';
  const VIEW_STORAGE_KEY = 'bitandbyte:favorites:view';
  const FAVORITES_VIEWS = new Set(['2', '3', '4', '5', 'vertical']);

  function normalizeFavoritesView(view) {
    const requestedView = FAVORITES_VIEWS.has(String(view)) ? String(view) : '4';

    // On mobile, keep only the two-column grid and the horizontal card view.
    // Desktop retains the existing 3/4/5-column choices.
    if (window.matchMedia('(max-width: 749px)').matches) {
      return ['3', '4', '5'].includes(requestedView) ? '2' : requestedView;
    }

    return requestedView === '2' ? '4' : requestedView;
  }

  function readFavoritesView() {
    try {
      const value = window.localStorage.getItem(VIEW_STORAGE_KEY) || '4';
      return FAVORITES_VIEWS.has(value) ? value : '4';
    } catch (error) {
      return '4';
    }
  }

  function applyFavoritesView(view) {
    const page = document.querySelector('[data-favorites-page]');
    if (!page) return;

    const selectedView = normalizeFavoritesView(view);
    page.classList.remove(
      'bit-favorites--view-3',
      'bit-favorites--view-4',
      'bit-favorites--view-5',
      'bit-favorites--view-vertical'
    );
    page.classList.add(`bit-favorites--view-${selectedView}`);

    document.querySelectorAll('[data-favorites-view]').forEach((button) => {
      const isActive = button.dataset.favoritesView === selectedView;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    try {
      window.localStorage.setItem(VIEW_STORAGE_KEY, selectedView);
    } catch (error) {
      // localStorage may be disabled by the browser or privacy mode.
    }
  }

  function readFavorites() {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(favorites) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    } catch (error) {
      // localStorage may be disabled by the browser or privacy mode.
    }
  }

  function updateFavoriteButton(button, isFavorite) {
    button.classList.toggle('is-favorite', isFavorite);
    button.setAttribute('aria-pressed', String(isFavorite));
    button.setAttribute(
      'aria-label',
      isFavorite ? 'Quitar de favoritos' : 'Agregar a favoritos'
    );
    const label = button.querySelector('[data-favorite-label]');
    if (label) label.textContent = isFavorite ? 'Quitar de favoritos' : 'Agregar a favoritos';
  }

  function updateAllFavoriteButtons() {
    const favoriteIds = new Set(readFavorites().map((item) => String(item.id)));
    document.querySelectorAll('[data-favorite-button]').forEach((button) => {
      updateFavoriteButton(button, favoriteIds.has(String(button.dataset.productId)));
    });
    document.querySelectorAll('[data-favorites-count]').forEach((count) => {
      count.textContent = String(favoriteIds.size);
      count.hidden = favoriteIds.size === 0;
    });
  }

  function celebrateFavoriteButton(button) {
    if (!button || !button.isConnected) return;
    button.classList.remove('is-celebrating');
    void button.offsetWidth;
    button.classList.add('is-celebrating');
    window.setTimeout(() => button.classList.remove('is-celebrating'), 850);
  }

  function productFromButton(button) {
    return {
      id: button.dataset.productId,
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      vendor: button.dataset.productVendor || '',
      stock: button.dataset.productStock || '',
      available: button.dataset.productAvailable === 'true',
      url: button.dataset.productUrl || '#',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || '',
      priceAmount: button.dataset.productPriceAmount || '',
      compareAtPrice: button.dataset.productCompareAtPrice || '',
      description: button.dataset.productDescription || button.dataset.productTitle || ''
    };
  }

  function showFavoriteToast(product, isFavorite) {
    let toast = document.querySelector('[data-favorites-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bit-favorites-toast';
      toast.dataset.favoritesToast = '';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.classList.toggle('is-removed', !isFavorite);
    toast.replaceChildren();

    const icon = document.createElement('span');
    icon.className = 'bit-favorites-toast__icon';
    icon.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path></svg>';

    const copy = document.createElement('span');
    copy.className = 'bit-favorites-toast__copy';

    const heading = document.createElement('strong');
    heading.textContent = isFavorite ? 'Se agregó a favoritos' : 'Se quitó de favoritos';
    const productTitle = document.createElement('span');
    productTitle.textContent = product.title;

    copy.append(heading, productTitle);
    toast.append(icon, copy);
    toast.classList.remove('is-visible');
    requestAnimationFrame(() => toast.classList.add('is-visible'));

    window.clearTimeout(toast.dismissTimer);
    toast.dismissTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  }

  function renderFavoritesPage() {
    const grid = document.querySelector('[data-favorites-grid]');
    const empty = document.querySelector('[data-favorites-empty]');
    if (!grid || !empty) return;

    const favorites = readFavorites();
    grid.replaceChildren();
    empty.hidden = favorites.length > 0;

    favorites.forEach((product) => {
      const item = document.createElement('li');
      item.className = 'grid__item';

      const card = document.createElement('div');
      card.className = 'card-wrapper wbproduct-container product-card-wrapper left bit-favorites__card';

      const favoriteButton = document.createElement('button');
      favoriteButton.type = 'button';
      favoriteButton.className = 'bit-favorite-button';
      favoriteButton.dataset.favoriteButton = '';
      favoriteButton.dataset.productId = product.id;
      favoriteButton.dataset.productHandle = product.handle;
      favoriteButton.dataset.productTitle = product.title;
      favoriteButton.dataset.productVendor = product.vendor || '';
      favoriteButton.dataset.productStock = product.stock || '';
      favoriteButton.dataset.productAvailable = String(product.available === true);
      favoriteButton.dataset.productUrl = product.url;
      favoriteButton.dataset.productImage = product.image;
      favoriteButton.dataset.productPrice = product.price;
      favoriteButton.dataset.productPriceAmount = product.priceAmount || '';
      favoriteButton.dataset.productCompareAtPrice = product.compareAtPrice || '';
      favoriteButton.dataset.productDescription = product.description;
      favoriteButton.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" focusable="false"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path></svg><span class="visually-hidden" data-favorite-label>Agregar a favoritos</span>';
      card.appendChild(favoriteButton);

      const productInfo = document.createElement('product-info');
      productInfo.id = `ProductInfo-favorites-${product.id}`;
      productInfo.dataset.layout = 'card';
      productInfo.dataset.url = product.url;
      const productCard = document.createElement('div');
      productCard.className = 'card card--card card--media color-background-1 gradient';
      productCard.style.setProperty('--ratio-percent', '100%');

      const cardInner = document.createElement('div');
      cardInner.className = 'card__inner wbimgblock ratio';
      cardInner.style.setProperty('--ratio-percent', '100%');
      const media = document.createElement('div');
      media.className = 'card__media';

      if (product.image) {
        const mediaItem = document.createElement('div');
        mediaItem.className = 'product__media-item';
        const imageLink = document.createElement('a');
        imageLink.className = 'media media--transparent media-- media--hover-effect';
        imageLink.href = product.url;
        const image = document.createElement('img');
        image.className = 'img-fluid mx-auto lazyload bit-favorites__image';
        image.src = product.image;
        image.alt = product.title;
        image.loading = 'lazy';
        imageLink.appendChild(image);
        mediaItem.appendChild(imageLink);
        media.appendChild(mediaItem);
      }
      cardInner.appendChild(media);

      const priceAmount = Number(product.priceAmount || 0);
      const compareAtPrice = Number(product.compareAtPrice || 0);
      if (compareAtPrice > priceAmount) {
        const badge = document.createElement('div');
        badge.className = 'card__badge quick_add_position-top-left';
        const saleBadge = document.createElement('span');
        saleBadge.className = 'badge percent__badge-sale';
        saleBadge.textContent = `${Math.round((1 - priceAmount / compareAtPrice) * 100)}% off`;
        badge.appendChild(saleBadge);
        cardInner.appendChild(badge);
      }
      productCard.appendChild(cardInner);

      const variant = document.createElement('wb-card-variant');
      const content = document.createElement('div');
      content.className = 'wbproductdes card__content';
      const information = document.createElement('div');
      information.className = 'card__information';

      if (product.vendor) {
        const vendor = document.createElement('div');
        vendor.className = 'product__vendor cardhide_toggle';
        vendor.textContent = product.vendor;
        information.appendChild(vendor);
      }

      const title = document.createElement('h3');
      title.className = 'cardhide_toggle card__heading h5 bit-favorites__title';
      const titleLink = document.createElement('a');
      titleLink.className = 'full-unstyled-link';
      titleLink.href = product.url;
      titleLink.textContent = product.title;
      title.appendChild(titleLink);
      information.appendChild(title);

      const cardInformation = document.createElement('div');
      cardInformation.className = 'card-information';

      const cardCaption = document.createElement('span');
      cardCaption.className = 'caption-large light cardhide_toggle';
      cardInformation.appendChild(cardCaption);

      if (product.price) {
        const price = document.createElement('div');
        price.className = 'no-js-hidden wbhprice bit-favorites__price';
        price.setAttribute('role', 'status');
        const priceSummary = document.createElement('div');
        priceSummary.className = 'card_product_Price';
        const priceText = document.createElement('span');
        priceText.className = 'card_sale_price';
        priceText.textContent = product.price;
        const compareText = document.createElement('small');
        compareText.className = 'card_compare_price';
        if (compareAtPrice > priceAmount && product.compareAtPrice) {
          compareText.textContent = product.compareAtPrice;
        }
        priceSummary.append(priceText, compareText);

        const priceContainer = document.createElement('div');
        priceContainer.className = 'price price__container card__default_price';
        const regularPrice = document.createElement('div');
        regularPrice.className = 'price__regular';
        const regularPriceText = document.createElement('span');
        regularPriceText.className = 'price-item price-item--regular';
        regularPriceText.textContent = product.price;
        regularPrice.appendChild(regularPriceText);
        const salePrice = document.createElement('div');
        salePrice.className = 'price__sale';
        const salePriceText = document.createElement('span');
        salePriceText.className = 'price-item price-item--sale price-item--last';
        salePriceText.textContent = product.price;
        const saleCompareText = document.createElement('small');
        saleCompareText.className = 'price-item price-item--regular';
        if (compareAtPrice > priceAmount && product.compareAtPrice) {
          saleCompareText.textContent = product.compareAtPrice;
        }
        salePrice.append(salePriceText, saleCompareText);
        priceContainer.append(regularPrice, salePrice);
        price.append(priceSummary, priceContainer);
        cardInformation.appendChild(price);
      }

      if (product.stock !== '' && Number.isFinite(Number(product.stock))) {
        const stockCount = Number(product.stock);
        const stock = document.createElement('div');
        stock.className = 'wbstockcount';
        const stockInfo = document.createElement('div');
        stockInfo.className = `wbstockinfo ${stockCount <= 10 ? 'wbstockinfo_low' : 'wbstockinfo_high'}`;
        stockInfo.textContent = stockCount <= 10 ? `Solo ${stockCount} Disponibles` : `${stockCount} Disponibles`;
        const stockBar = document.createElement('div');
        stockBar.className = 'wbstockinfo-bar';
        const stockProgress = document.createElement('span');
        stockProgress.className = 'wbstockinfo-probar';
        stockProgress.style.width = `${Math.max(0, (stockCount / 150) * 100)}%`;
        stockBar.appendChild(stockProgress);
        stock.append(stockInfo, stockBar);
        cardInformation.appendChild(stock);
      }

      if (product.description) {
        const description = document.createElement('div');
        description.className = 'bit-product-short-description';
        description.textContent = product.description;
        cardInformation.appendChild(description);
      }

      information.appendChild(cardInformation);
      content.appendChild(information);
      variant.appendChild(content);

      const actions = document.createElement('div');
      actions.className = 'no-js-hidden selectedbtn';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'add-to-cart__submit button button--primary bit-favorites__remove';
      remove.dataset.favoriteRemove = product.id;
      const removeLabel = document.createElement('span');
      removeLabel.textContent = 'Quitar De Favoritos';
      remove.appendChild(removeLabel);
      actions.appendChild(remove);
      variant.appendChild(actions);

      productCard.appendChild(variant);
      productInfo.appendChild(productCard);
      card.appendChild(productInfo);

      item.appendChild(card);
      grid.appendChild(item);
    });

    updateAllFavoriteButtons();
  }

  function toggleFavorite(button) {
    const product = productFromButton(button);
    const favorites = readFavorites();
    const currentIndex = favorites.findIndex((item) => String(item.id) === String(product.id));
    const isFavorite = currentIndex === -1;

    if (isFavorite) {
      favorites.push(product);
    } else {
      favorites.splice(currentIndex, 1);
    }

    writeFavorites(favorites);
    updateAllFavoriteButtons();
    renderFavoritesPage();
    const buttonToAnimate = Array.from(document.querySelectorAll('[data-favorite-button]')).find(
      (currentButton) => String(currentButton.dataset.productId) === String(product.id)
    ) || button;
    celebrateFavoriteButton(buttonToAnimate);
    showFavoriteToast(product, isFavorite);
  }

  document.addEventListener('click', function (event) {
    const viewButton = event.target.closest('[data-favorites-view]');
    if (viewButton) {
      event.preventDefault();
      applyFavoritesView(viewButton.dataset.favoritesView);
      return;
    }

    const favoriteButton = event.target.closest('[data-favorite-button]');
    if (favoriteButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleFavorite(favoriteButton);
      return;
    }

    const removeButton = event.target.closest('[data-favorite-remove]');
    if (removeButton) {
      const favoriteCard = removeButton.closest('.bit-favorites__card');
      const productTitle = favoriteCard?.querySelector('.bit-favorites__title')?.textContent.trim() || 'Producto';
      const favorites = readFavorites().filter(
        (item) => String(item.id) !== String(removeButton.dataset.favoriteRemove)
      );
      writeFavorites(favorites);
      updateAllFavoriteButtons();
      renderFavoritesPage();
      showFavoriteToast({ title: productTitle }, false);
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      updateAllFavoriteButtons();
      renderFavoritesPage();
    }
  });

  document.addEventListener('bit:favorites:refresh', updateAllFavoriteButtons);

  function initializeFavorites() {
    applyFavoritesView(readFavoritesView());
    updateAllFavoriteButtons();
    renderFavoritesPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFavorites);
  } else {
    initializeFavorites();
  }
})();
